import { RoutePaths } from 'constant';
import { RouteLevelEventTags } from 'hooks/use-data-dog-logger';
import {
  matchForCreateNewProjectModal,
  matchForProjectOverview,
  matchForProjectPlanDetails,
  matchForProjectTasks,
  matchForProjectTasksList,
  matchForResourceManagement,
  matchForTimesheetReports,
  matchForTimesheetSingleUserApprovals,
  matchForTimesheets,
} from 'utils/match-by-route-path';

export class InitRouter {
  private visitedPaths = {};

  private static instance: InitRouter | undefined;

  public static readonly getInstance = () => {
    if (!this.instance) {
      this.instance = new InitRouter();
    }

    return this.instance;
  };

  public enter = (pathName: string) => {
    if (pathName) {
      // Enabled only for nitro accounts
      this.visitedPaths[pathName] = true;
    }
  };

  public isVisited = (pathName: string) => {
    return pathName && this.visitedPaths[pathName] === true;
  };

  public tagNames = (pathName: string) => {
    const visitedPath = this.isVisited(pathName);

    switch (pathName) {
      case RoutePaths.home: {
        return visitedPath
          ? [RouteLevelEventTags.HomePageRouteChange]
          : [RouteLevelEventTags.HomePageLoad];
      }
      case RoutePaths.projects: {
        return visitedPath
          ? [RouteLevelEventTags.ProjectListRouteChange]
          : [RouteLevelEventTags.ProjectListPageLoad];
      }
      default:
        if (matchForCreateNewProjectModal(pathName)) {
          return visitedPath
            ? [RouteLevelEventTags.CreateNewProjectModalRouteChange]
            : [RouteLevelEventTags.CreateNewProjectModal];
        }
        if (matchForProjectPlanDetails(pathName)) {
          return visitedPath
            ? [RouteLevelEventTags.ProjectPlanRouteChange]
            : [RouteLevelEventTags.ProjectPlanPageLoad];
        }
        if (matchForTimesheets(pathName)) {
          return visitedPath
            ? [RouteLevelEventTags.TimesheetsRouteChange]
            : [RouteLevelEventTags.TimesheetsPageLoad];
        }
        if (matchForProjectTasksList(pathName)) {
          return visitedPath
            ? [RouteLevelEventTags.ProjectTasksListRouteChange]
            : [RouteLevelEventTags.ProjectTasksListPageLoad];
        }
        if (matchForProjectTasks(pathName)) {
          return visitedPath
            ? [RouteLevelEventTags.TasksListRouteChange]
            : [RouteLevelEventTags.TasksListPageLoad];
        }
        if (matchForTimesheetReports(pathName)) {
          return visitedPath
            ? [RouteLevelEventTags.TimesheetReportsRouteChange]
            : [RouteLevelEventTags.TimesheetReportsPageLoad];
        }
        if (matchForTimesheetSingleUserApprovals(pathName)) {
          return visitedPath
            ? [RouteLevelEventTags.TimesheetsSingleUserRouteChange]
            : [RouteLevelEventTags.TimesheetsSingleUserPageLoad];
        }
        if (matchForResourceManagement(pathName)) {
          return visitedPath
            ? [RouteLevelEventTags.ResourceManagementRouteChange]
            : [RouteLevelEventTags.ResourceManagementLoad];
        }
        if (matchForProjectOverview(pathName)) {
          return visitedPath
            ? [RouteLevelEventTags.OverviewRouteChange]
            : [RouteLevelEventTags.OverviewPageLoad];
        }

        return [];
    }
  };
}
